export enum AuthorityFiscalCoupon {
  FISCAL_COUPON_SETTING = '17.1',
  FISCAL_COUPON_VIEW_LIST = '17.2',
  FISCAL_COUPON_GENERATE_IN_WORKORDER = '17.3',
  FISCAL_COUPON_VIEW_DETAIL = '17.4',
  FISCAL_COUPON_EDIT = '17.5',
  FISCAL_COUPON_REMOVE = '17.6',
  FISCAL_COUPON_UPLOAD_DOWNLOAD_SAT_FILE = '17.7',
  FISCAL_COUPON_EMISSION = '17.8',
  FISCAL_COUPON_CANCELLATION = '17.9',
  FISCAL_COUPON_PRINT = '17.10',
}
